import React from 'react'

import { withErrorBoundary } from 'common/components/ErrorBoundary/error_boundary'

import Private from 'vendor/pages/Private/private'
import Public from 'vendor/pages/Public/public'
import { AllProviders } from 'vendor/providers'

/* Load axios to set headers configuration */
import 'common/data-access/axios'

const Application = (props) => {
  const Component = props['companyVendorContactId'] ? Public : Private

  return (
    <AllProviders>
      <Component {...props} />
    </AllProviders>
  )
}

export default withErrorBoundary(Application)
